import { useEffect } from "react";
import { useState } from "react";
import { useGlobalConfig } from "providers/GlobalConfig";
import { GlobalConfigType } from "types/configs";
import { isFlagActive } from "models/featureFlags";

/**
 * Custom hook to check if a feature flag is enabled for the current tenant.
usage:
  * const isFeatureEnabled = useFeatureFlag("featureName");
  * {isFeatureEnabled && <SomeComponent />}
 */

export const useFeatureFlag = (flagName: string) => {
  const { globalConfig } = useGlobalConfig()! as GlobalConfigType;
  const [isEnabled, setIsEnabled] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (!globalConfig?.tenant) {
      setIsEnabled(undefined);
      return;
    }
    setIsEnabled(isFlagActive(flagName, globalConfig.tenant));
  }, [globalConfig?.tenant, flagName]);

  return isEnabled;
};
